import { createAction } from '@reduxjs/toolkit'
import { TooltipPayload } from 'types/storeTypes'

export const showTooltip = createAction<TooltipPayload>('@TOOLTIP/SHOW_TOOLTIP')

export const hideTooltip = createAction('@TOOLTIP/HIDE_TOOLTIP')
